//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const DeleteCommentsAttachments: FeatureFlag = {"Id":"DeleteCommentsAttachments","Label":"Allow reviewers to delete comments and attachments","Impact":"Reviewer can delete comments and comment file attachments","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
